import ModalManager from 'global/modal/ModalManager';
import AddToCartBackOrder from 'global/addToCart/AddToCartBackOrder';
import { addToCartTagging } from 'global/tagging/globalTaggingEvents';
import addToCartVariantStatus from 'global/addToCart/addToCartVariantStatus';
import { GtmTrackingType } from '../constants';
import { initProductLists } from '../recomendations/initRecommendations';

const addToCartButton = 'data-add-to-cart';

class AddToCartModalManager extends ModalManager {
	showModal() {
		super.showModal();

		if (this.modalHtml.querySelectorAll('#addToCartBackOrderModal').length) {
			return new AddToCartBackOrder(this);
		}

		const taggingData = getTaggingData(this.modalHtml);
		addToCartTagging(taggingData);
		populateCrossSellZones(this.modalHtml);
		return this;
	}
}

const getTaggingData = modalHtml => {
	// TODO Data comes from server so needs to be call something more generic like in signalData.tag
	const signalDiv = modalHtml.querySelector('[data-signal]');
	const signalString = signalDiv ? signalDiv.textContent : '{}';
	let signalJson;
	try {
		signalJson = JSON.parse(signalString);
	} catch (jsonError) {
		signalJson = {};
	}

	// Add additional boolean determining whether referal page is a product variant page
	try {
		const { pageType, pageReferer, variants } =
			window.od.journeyData.navigation;
		if (pageType === 'product') {
			signalJson.navigation.isRefererVariant = addToCartVariantStatus({
				pageType,
				pageReferer,
				variants,
			});
		}
	} catch (error) {
		if (console) console.error(error); // eslint-disable-line no-console
	}

	window.od.events.publish(GtmTrackingType.ADD_TO_BASKET, signalJson);
	return signalJson;
};

const setTaggingData = zone => {
	zone.element.addEventListener('click', e => {
		const button = e.target.closest('BUTTON');
		if (button && button.hasAttribute(addToCartButton)) {
			const navigationMethod = e.currentTarget.getAttribute(
				'data-navigation-method',
			);
			const placementType = e.currentTarget.getAttribute(
				'data-related-product-zone',
			);

			window.od.events.publish('addToCart_Modal', {
				navigationMethod,
				placementType,
			});
		}
	});
};

const populateCrossSellZones = modalHtml => {
	initProductLists(modalHtml, undefined, undefined, true).then(productZones => {
		let hasCrossSell = false;
		if (!productZones && !Array.isArray(productZones)) {
			return;
		}

		productZones.forEach(zone => {
			if (zone.hasProducts()) {
				hasCrossSell = true;
			}

			setTaggingData(zone);
		});

		if (hasCrossSell) {
			duplicateFooter(modalHtml);
		}
	});
};

const duplicateFooter = modalHtml => {
	const topButtons = modalHtml.querySelector(
		'.modal-add-to-cart__continue-buttons',
	);
	const bottomButtons = topButtons.cloneNode(true);
	topButtons.parentElement.appendChild(bottomButtons);
};

export default AddToCartModalManager;
